import Fields from '@/views/backstage/structure/detail_page/common/MetadataFields'

export default 
    (type, front_back = 'backstage') => {
        let ret = {
            name: '林業資料',
            type: 'group',
            fields: null
        }

        switch(type){
        case 'official_document':
        case 'graph':
        case 'image':
        case 'oral_history':
        case 'publication':
        case 'cultural_relics':
        case 'culture_natural_landscape':
        case 'buildings':
            ret['fields'] = [
                Fields['business_district_forest'],
                Fields['security_forest'],
            ]
            break
        default:
            ret['fields'] = null
            break
        }

        return ret
    }
